import ApiService from "@/services/ApiService";
import TokenService from "@/services/TokenService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import AuthorizationService from "@/services/AuthorizationService";

export default {
  namespaced: true,
  state: {
    accessToken: TokenService.getToken(),
    errors: null,
    authIsChecked: false
  },

  getters: {
    loggedIn: state => !!state.accessToken,
    isSomeError: state => !!state.errors,
    getErrors: state => new ErrorHandlerService(state.errors, "login"),
    authIsChecked: state => state.authIsChecked
  },

  actions: {
    async checkAuth({ commit, getters }) {
      if (getters.loggedIn) {
        ApiService.setHeader();
        if (!this.getters["user/getUser"]) {
          await this.dispatch("user/getUser");
        }
      }
      commit("setAuthIsChecked", true);
      return getters.loggedIn;
    },

    async login({ commit, dispatch }, user) {
      try {
        let res = await AuthorizationService.getAccessToken(user);
        TokenService.saveToken(res.data.token);
        ApiService.setHeader();
        commit("setErrors", null);
        await this.dispatch("user/getUser");
        commit("setLoginSuccess", res.data.token);
      } catch (err) {
        commit("setErrors", err.response.data);
      }
    },

    async registerFromAppointment({ commit, dispatch }, { user, code }) {
      try {
        await AuthorizationService.registerFromAppointment(user.password, code);
        await dispatch("login", user);

        return true;
      }
      catch (err) {
        commit("setErrors", err.response.data);
      }

      return false;
    },

    async sendRecoverLetter({ commit }, email) {
      try {
        await AuthorizationService.sendRecoverLetter(email);
      } catch (err) {
        commit("setErrors", err.response.data);
      }
    },

    async recoverPassword({ commit }, { email, token, new_password }) {
      let res = false;
      try {
        await AuthorizationService.resetPassword({
          email,
          token,
          new_password
        });
        res = true;
      } catch (err) {
        commit("setErrors", err.response.data);
        res = false;
      }
      return res;
    },

    async logout({ commit, dispatch }) {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      ApiService.removeHeader();
      commit("setLoginSuccess", null);
      this.dispatch("user/clearUser");
    }
  },
  mutations: {
    setAuthIsChecked(state, check) {
      state.authIsChecked = check;
    },
    setLoginSuccess(state, accessToken) {
      state.accessToken = accessToken;
    },
    setErrors(state, errors) {
      state.errors = errors;
    }
  }
};
